<template>
  <div>
    <div class="header" :style="'background-color:'+bg_color">
      <div class="w1100">
        <div class="left">
          <input
            v-if="search_show"
            v-model="keywordSlef"
            v-on:keyup.enter="subKeyword()"
            type="text"
            placeholder="搜索伙伴"
          >
        </div>

        <div class="right">
          <div class="gohome" @click="$router.push('/')">登录/注册</div>
        </div>
      </div>

    </div>

    <div style="height:48px;"></div>
  </div>
</template>

<script>
export default {
  props: {
    search_show: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    },
    keyword: {
      type: String,
      default: null
    },
      bg_color: {
          type: String,
          default: '#FFF'
      },
      bline: {
          type: String,
          default: '#EAEAEA'
      },
  },
  data() {
    return {
      PeopleState: false, //people
      newsState: false, //news
      pCenterState: false, //个人中心
      talkContent: null,
      showWord: true,
      talkShow: false,
      talkStatus: 1, //1输入框 2=提示信息
      userInfo: {},
      content: "",
      interact_num: 0, //互动数量
      message_num: 0, //消息数量
      page_num: 6, //获取10条消息
      page_num2: 16, //获取10条消息
      messageList: [], //消息记录,
      keywordSlef: this.keyword,
      interactList: [], //互动记录
      linkers: 0,
      follows: 0
    };
  },
  created() {

  },

  methods: {


    //搜索
    subKeyword() {
      let _this = this;
      _this.common.onLoginSure();
    },


  }
};
</script>

<style scoped lang='less'  rel="stylesheet/less">
@import "../assets/css/index.less";

.header {
  background: #fff;
  padding: 7px 0;
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  .w1100 {
    .flexSBetween;
  }
  .left {
    input {
      width: 328px;
      height: 32px;
      text-indent: 22px;
      background: #ededed;
      border-radius: 16px;
    }
  }

  .title {
    font-weight: 600;
    height: 24px;
    line-height: 24px;
    border-bottom: 3px black solid;
  }

  .right {
    position: relative;

    // people下拉
    .linkCont {
      width: 374px;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(153, 152, 152, 1);
      position: absolute;
      top: 38px;
      right: 22px;
      z-index: 10;
      height: 518px;
      overflow: auto;

      .div1 {
        width: 374px;
        height: 518px;
        position: relative;
        overflow: hidden;
      }
      .div2 {
        overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
      }
      .div3 {
        width: 374px;
        height: 518px;
      }

      ul {
        li {
          border-bottom: 1px solid #e0e0e0;
          padding: 14px;
          .flexSBetween;
          .ImgName {
            .flexStart;
            .img {
              width: 42px;
              height: 42px;
              margin-right: 16px;
              img {
                width: 42px;
                height: 42px;
                .border-radius(50%);
              }
            }
            .imgnames {
              color: #000;
              font-size: 14px;
              .nameWord {
                font-weight: bold;
                 color: #484848;
              }
              .nameWord:hover{
                color: #2D6281;
                text-decoration: underline;
              }
              .linkBlue {
                color: #157ECF;
              }
              .wood{
                color: #484848;
                 font-weight: bold;
              }
              .contWord{
                .twoLines();
                margin: 10px 0;
              }
              .time {
                color: #919191;
              }
            }
          }
          .choes {
            .flexStart;
            .yes,
            .no {
              width: 20px;
              height: 20px;
              text-align: center;
              color: #fff;
              .border-radius(50%);
              cursor: pointer;
            }
            .yes {
              margin-right: 20px;
            }
            .no {
            }
          }
          .choesimg {
            .imgCut(60px, 60px);
          }
        }
      }
      .lookAll {
        color: #2d6281;
        font-size: 14px;
        text-align: center;
        padding: 19px 0;
        display: block;
        cursor: pointer;
      }
      .lookAll:hover {
        text-decoration: underline;
      }
    }
    //消息
    .newsCont {
      width: 374px;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(153, 152, 152, 1);
      position: absolute;
      top: 38px;
      right: 22px;
      z-index: 10;
      height: 518px;
      overflow: auto;

      .div1 {
        width: 374px;
        height: 518px;
        position: relative;
        overflow: hidden;
      }
      .div2 {
        overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
      }
      .div3 {
        width: 374px;
        height: 518px;
      }

      ul {
        li {
          border-bottom: 1px solid #e0e0e0;
          padding: 14px;
          cursor: pointer;
          .flexSBetween;
          .ImgName {
            .flexStart;
            .img {
              width: 42px;
              height: 42px;
              margin-right: 16px;
              img {
                width: 42px;
                height: 42px;
                .border-radius(50%);
              }
            }

            .newsName {
              .names {
                color: #484848;
                font-size: 14px;
                font-weight: 400;
              }
              .namesBold {
                color: #484848;
                font-size: 14px;
                font-weight: bold;
              }

              .time {
                color: #7f7f7f;
              }
              .word {
                color: #7f7f7f;
                font-size: 14px;
                .oneLines;
              }
              .word:hover {
                text-decoration: underline;
              }
            }
          }
          .readed {
            span {
              width: 10px;
              height: 10px;
              display: inline-block;
              background: #3799f5;
              border-radius: 50%;
            }
          }
        }
      }
      .lookAll {
        color: #2d6281;
        font-size: 14px;
        text-align: center;
        padding: 19px 0;
        display: block;
        cursor: pointer;
      }
      .lookAll:hover {
        text-decoration: underline;
      }
    }

    //news 下拉
    .pCenterCont {
      width: 266px;
      background: #f6f6f6;
      box-shadow: 0px 2px 4px 0px rgba(153, 152, 152, 1);
      position: absolute;
      top: 38px;
      right: 22px;
      z-index: 10;
      padding: 16px;
      .titNum {
        margin-bottom: 22px;

        .flexSBetween;

        .newsName,
        .newsNum {
          font-size: 16px;
        }
        .newsName {
          color: #1d1d1d;
          cursor: pointer;
        }
        .newsName:hover {
          text-decoration: underline;
        }
        .newsNum {
          color: #7f7f7f;
        }
      }
      .talkTo {
        color: #1d1d1d;
        font-size: 16px;
        padding-top: 22px;
        display: block;

        border-top: 1px solid #e5e5e5;
        cursor: pointer;
      }
      .talkTo:hover {
        text-decoration: underline;
      }
    }
    .flexEnd;
    .name {
      color: #2c2c2c;
      font-size: 14px;
      margin-left: 20px;
    }
    .line {
      background: #e2e2e2;
      width: 2px;
      height: 24px;
      margin-left: 20px;
    }
    .gohome {
      color: #2c2c2c;
      font-size: 14px;
      cursor: pointer;
      margin-left: 20px;
    }
    .gohome:hover {
      text-decoration: underline;
    }

    .people,
    .news {
      img {
        width: 100%;
        height: 100%;
      }
      width: 18px;
      height: 18px;
      position: relative;
      margin-left: 20px;
      cursor: pointer;
      .num {
        .positionART(-10px, -10px);
        background: #ff0000;
        border-radius: 7px;
        color: #fff;
        font-size: 12px;
        padding: 2px 5px;
      }
    }
    .pCenter {
      margin-left: 20px;
      cursor: pointer;
    }
  }
}
.talk-body {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(28, 28, 28, 0.5);
  z-index: 99;
  justify-content: center;
  align-items: center;
  display: flex;
  .talk-content {
    width: 719px;
    height: 460px;
    background-color: white;
    border-radius: 10px;
    z-index: 99;
    text-align: center;
    .div1 {
      width: 719px;
      height: 360px;
      position: relative;
      overflow: hidden;
    }
    .div2 {
      overflow-x: hidden;
      overflow-y: scroll;
      position: absolute;
    }
    .div3 {
      width: 719px;
      height: 360px;
    }

    textarea {
      overflow: hidden;
      resize: none;
      color: #1d1d1d;
      font-size: 14px;
      outline: none;
      resize: none;
      border: none;
      background: transparent;
      margin-top: 20px;
      width: 600px;
      height: 360px;
    }
    .talkSub {
      height: 54px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(22, 101, 147, 1);
      line-height: 54px;
      cursor: pointer;
    }
    .talkSub:hover {
      color: rgba(22, 101, 147, 0.7);
    }
  }
  .talk-message {
    width: 719px;
    height: 170px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin-top: -300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    i {
      width: 118px;
      height: 118px;
      border-radius: 50%;
      margin-left: 20px;
      text-align: center;
      line-height: 118px;
      color: white;
      background-color: #4dd113;
      font-size: 65px;
      font-weight: 600;
    }
    div {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(28, 28, 28, 1);
      line-height: 24px;
      margin-left: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/headerLogin.vue